__turbopack_context__.v({
  "childWrapper": "Section-module-scss-module__JzF6cq__childWrapper",
  "navigationButton": "Section-module-scss-module__JzF6cq__navigationButton",
  "section": "Section-module-scss-module__JzF6cq__section",
});
